import * as Types from './Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { RootState } from 'src/reducers/RootReducer';

export interface DeleteProjectTeamMemberAttempt extends Action {
  type: Types.DELETE_PROJECT_TEAM_MEMBER_ATTEMPT;
}

export interface DeleteProjectTeamMemberSuccess extends Action {
  type: Types.DELETE_PROJECT_TEAM_MEMBER_SUCCESS;
}

export interface DeleteProjectTeamMemberFailure extends Action {
  type: Types.DELETE_PROJECT_TEAM_MEMBER_FAILURE;
  payload: {};
}

export type DeleteProjectTeamMemberAction =
  DeleteProjectTeamMemberAttempt
  | DeleteProjectTeamMemberSuccess
  | DeleteProjectTeamMemberFailure;

export interface DeleteProjectTeamMemberThunk extends
  ThunkAction<Promise<DeleteProjectTeamMemberAction>, RootState, string> {
}

export const deleteProjectTeamMemberAttempt: ActionCreator<DeleteProjectTeamMemberAttempt> = () => (
  {
    type: Types.DELETE_PROJECT_TEAM_MEMBER_ATTEMPT
  }
);

export const deleteProjectTeamMemberSuccess: ActionCreator<DeleteProjectTeamMemberSuccess> = () => (
  {
    type: Types.DELETE_PROJECT_TEAM_MEMBER_SUCCESS
  }
);

export const deleteProjectTeamMemberFailure: ActionCreator<DeleteProjectTeamMemberFailure> = (error: {}) => (
  {
    type: Types.DELETE_PROJECT_TEAM_MEMBER_FAILURE,
    payload: error
  }
);

export const deleteProjectTeamMember: ActionCreator<DeleteProjectTeamMemberThunk> =
  (projectId: string, teamMemberId: string): DeleteProjectTeamMemberThunk => {
    return (dispatch: Dispatch<RootState>): Promise<DeleteProjectTeamMemberAction> => {
      dispatch(deleteProjectTeamMemberAttempt());

      return ApiClient.projectTeamMember.delete(projectId, teamMemberId)
        .then((): DeleteProjectTeamMemberSuccess => {
          return dispatch(deleteProjectTeamMemberSuccess());
        }).catch((): DeleteProjectTeamMemberFailure => {
          return dispatch(deleteProjectTeamMemberFailure());
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/project/team-member/delete/DeleteProjectTeamMember.actions.tsx